// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"0769be18","36":"3ce00404","222":"3700a7e4","231":"a3ee5616","318":"ad92321a","371":"b3f0c761","423":"f30078e3","465":"38a2ee14","488":"99b41410","569":"b658ba14"}[chunkId] + ".chunk.js";
};